import React, { useEffect, useRef } from 'react';
import './Programs.css';

const Programs = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const cards = gridRef.current?.querySelectorAll('.program-card');
    cards?.forEach((c) => observer.observe(c));
    return () => cards?.forEach((c) => observer.unobserve(c));
  }, []);

  const programs = [
    { icon: '\uD83C\uDF1F', title: 'Pre-Primary', grades: 'Nursery - KG', description: 'A nurturing environment for early learners with play-based education that builds confidence, social skills, and a love for learning.', features: ['Montessori Methods', 'Creative Play', 'Early Literacy'] },
    { icon: '🎒', title: 'Primary School', grades: 'Grades 1-5', description: 'Building strong foundations with engaging curriculum that sparks curiosity and develops essential skills.', features: ['Interactive Learning', 'Play-based Activities', 'Character Building'] },
    { icon: '📖', title: 'Middle School', grades: 'Grades 6-8', description: 'Preparing students for academic challenges with comprehensive subjects and critical thinking skills.', features: ['Subject Specialization', 'Lab Experiments', 'Project-Based Learning'] },
    { icon: '🎓', title: 'High School', grades: 'Grades 9-12', description: 'Rigorous academic program preparing students for higher education and career success.', features: ['College Preparation', 'Career Counseling', 'Advanced Courses'] },
    { icon: '🔬', title: 'Science Stream', grades: 'Grades 11-12', description: 'Specialized program for students pursuing careers in science, engineering, and medicine.', features: ['Physics & Chemistry', 'Biology/Mathematics', 'Computer Science'] },
    { icon: '💼', title: 'Commerce Stream', grades: 'Grades 11-12', description: 'Comprehensive business education preparing students for careers in commerce and finance.', features: ['Accountancy', 'Business Studies', 'Economics'] },
    { icon: '🎨', title: 'Arts & Humanities', grades: 'Grades 11-12', description: 'Exploring creativity and critical analysis through literature, history, and social sciences.', features: ['Literature', 'History', 'Psychology'] },
  ];

  return (
    <section id="programs" className="programs">
      <div className="container">
        <div className="section-title">
          <h2>Our Academic Programs</h2>
          <p>Comprehensive educational programs designed to nurture every student's potential</p>
        </div>
        <div className="programs-grid" ref={gridRef}>
          {programs.map((program, index) => (
            <div className="program-card" key={index} style={{ transitionDelay: `${index * 0.1}s` }}>
              <div className="program-icon">{program.icon}</div>
              <div className="program-header">
                <h3>{program.title}</h3>
                <span className="program-grades">{program.grades}</span>
              </div>
              <p className="program-description">{program.description}</p>
              <ul className="program-features">
                {program.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="check-icon">{'\u2713'}</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <a href="#enroll" className="program-link">Learn More {'\u2192'}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
